import { createSlice } from '@reduxjs/toolkit';

// Define a slice using createSlice
const adminProgramSlice = createSlice({
    name: 'adminProgram',
    initialState: { id: '', branch: 'Master' },
    reducers: {
      setProgramId: (state, action) => {
        state.id = action.payload;
      },
      setBranch: (state, action) => {
        state.branch = action.payload;
      },
    },
  });

  // Export the action creator functions
export const { setProgramId, setBranch } = adminProgramSlice.actions;
export default adminProgramSlice